module.exports = __webpack_public_path__ + "img/workPermit7.d4d74a6e.png";